import { ReactNode } from 'react';
import classnames from 'classnames';

import { PolymorphicComponent } from '@hh.ru/magritte-types';

import styles from './styles.less';

interface ComponentProps {
    selected?: boolean;
    mobile?: boolean;
    children: ReactNode;
    Element?: 'div';
}

type Props = PolymorphicComponent<ComponentProps, 'div'>;

const HeaderNavItem: Props = ({ Element = 'div', selected, mobile, children, ...ElementProps }) => (
    <Element
        className={classnames(styles.navItem, {
            [styles.navItemMobile]: mobile,
            [styles.navItemSelected]: selected,
        })}
        {...ElementProps}
    >
        {children}
    </Element>
);

export default HeaderNavItem;
